import { useMutation } from '@tanstack/react-query';
import {
  downloadEstateDispositionSummary,
  downloadFinalReport,
} from '@/entities/report/report.api';

export const useDownloadFinalReportMutation = (options = {}) =>
  useMutation({
    mutationFn: (decedentId) => downloadFinalReport(decedentId),
    ...options,
  });

export const useDownloadEstateDispositionSummaryMutation = (options = {}) =>
  useMutation({
    mutationFn: (decedentId) => downloadEstateDispositionSummary(decedentId),
    ...options,
  });
